// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5057035f","453":"48921f18","455":"9560a198","977":"88beb0e9"}[chunkId] + ".chunk.js";
};